import React from "react";
import RecordRouter from './Record/Router';
export { getFields } from './Record/Router';

export default function RecordSupplierRouter(props) {
    return (
        <RecordRouter {...props} mode='SUPPLIER' />
    );
};
